import { __exports as e } from "../../../../_virtual/clone.js";
Object.defineProperty(e, "__esModule", { value: !0 });
e.clone = void 0;
function o(r) {
  return r ? JSON.parse(JSON.stringify(r)) : null;
}
e.clone = o;
export {
  e as default
};
